import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { datadogLogs } from '@datadog/browser-logs';
import { StatusCodes } from 'http-status-codes';

/** Dev-only WebSocket / HMR noise; do not send it to Browser Logs. */
const DEV_WS_NOISE = /webpack-dev-server|ng-cli-ws|WebSocket connection to.*failed/i;

@Injectable()
export class AppErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}

  get router(): Router {
    return this.injector.get(Router);
  }

  get zone(): NgZone {
    return this.injector.get(NgZone);
  }

  private navigateTo(routeParams: any) {
    this.zone.run(async () => this.router.navigate(routeParams, { skipLocationChange: true }));
  }

  /** Returns true if the error is dev-only WebSocket/HMR noise. */
  private static isDevWebSocketNoise(error: unknown): boolean {
    if (error == null) return false;
    const msg = typeof (error as { message?: string }).message === 'string' ? (error as { message: string }).message : '';
    const stack = typeof (error as { stack?: string }).stack === 'string' ? (error as { stack: string }).stack : '';
    return DEV_WS_NOISE.test(msg) || DEV_WS_NOISE.test(stack);
  }

  handleError(error: any) {
    if (AppErrorHandlerService.isDevWebSocketNoise(error)) {
      return;
    }
    if (error instanceof HttpErrorResponse) {
      switch (error.status) {
        case StatusCodes.NOT_FOUND:
          this.navigateTo(['not_found']);
          break;
        default:
          break;
      }
    }
    console.error(error);
    datadogLogs.logger.error('Unhandled application error', {
      status: error?.status,
      message: error?.message,
      url: window.location.href,
    }, error instanceof Error ? error : undefined);
  }
}
